import _ from "lodash";
export default {
  methods: {
    formIsPristineCommon(form, cloneForm) {
      return _.isEqual(form, cloneForm);
    }
  }
};
